import React from "react";

export default function PageHero({ eyebrow, title, highlight, copy, image }) {
  return (
    <section
      data-testid="page-hero"
      className="relative isolate bg-[#002366] text-white pt-36 pb-20 md:pt-44 md:pb-28 overflow-hidden"
    >
      {image && (
        <>
          <div className="absolute inset-0 -z-20">
            <img src={image} alt="" className="w-full h-full object-cover opacity-30" />
          </div>
          <div className="absolute inset-0 -z-10 bg-gradient-to-b from-[#002366]/80 via-[#002366]/90 to-[#002366]" />
        </>
      )}

      <div className="container-x relative">
        <p className="overline text-[#3366FF]">{eyebrow}</p>
        <div className="gold-rule mt-5 mb-6" />
        <h1 className="font-heading font-light tracking-tight text-4xl sm:text-5xl lg:text-6xl leading-[1.05] max-w-4xl">
          {title}{" "}
          {highlight && <span className="font-black text-[#3366FF]">{highlight}</span>}
        </h1>
        {copy && (
          <p className="mt-6 text-slate-300/85 text-base md:text-lg leading-relaxed max-w-2xl">
            {copy}
          </p>
        )}
      </div>
    </section>
  );
}
